// extracted by mini-css-extract-plugin
module.exports = {"preloader":"App_preloader__2wUyC","content":"App_content__1Wt3K"};